export default "__VITE_ASSET__lDQgYYcF__"